import { loginRequestConfig } from "../../../config/authConfig";
import { post } from "../../../services/request";

// export const login = (data) => post("User/UserSSOSignIn", data);
export const login = (data) => post("Coaxion/SignIn/SSOLogin", data);
export const customLogin = (data) => post("Coaxion/SignIn/CustomSignIn", data);

export const handleMicrosoftLogin = async ({ instance, accounts }) => {
  try {
    // Check if there's already an active account
    if (accounts.length > 0) {
      // User is already signed in, get token silently
      const silentRequest = {
        ...loginRequestConfig,
        account: accounts[0],
      };

      // debugger
      const response = await instance.acquireTokenSilent(silentRequest);
      return response;
    } else {
      // No active account, trigger popup login
      // debugger
      const response = await instance.loginPopup(loginRequestConfig);
      return response;
    }
  } catch (error) {
    console.error("Microsoft login failed:", error);
  }
};
